import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Modal, Button } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import { fetchStatusModal, fetchUpdateDadosMinimizados } from 'store/fetchActions/fetchApp';
import { ENUM_MODAL } from 'utils/consts';
import Loading from 'components/Loading';
import Historico from './ModalHistorico';
import ReatendimentoAtendente from './reatendimentoAtendente';
import SucessoRequerimento from './sucessoRequerimento';
import ValidateCaptcha from './validateCaptcha';
import ResumoRequerimento from './ModalResumoRequerimento';
import HistoricoRelatorioRequerimento from './ModalHistoricoRelatorioRequerimento';

export const ModalGenerico = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const modalAcessoNegado = useSelector(state => state.app.modalAcessoNegado);
  const modalState = useSelector(state => state.app.modal);
  const dadosHistorico = useSelector(state => state.formulario.dadosHistorico);

  React.useEffect(() => {
    if (modalAcessoNegado?.isOpen && modalState?.isOpen) {
      dispatch(fetchStatusModal(false, ''));
    }
  }, [dispatch, modalAcessoNegado, modalState]);

  const onClose = () => {
    const rota = modalState?.props?.rota;
    if (rota) history.push(rota);
    dispatch(fetchStatusModal(false, ''));
    dispatch(fetchUpdateDadosMinimizados({}));
  };

  const chooseModal = () => {
    if (modalState?.isOpen) {
      if (modalState?.title === ENUM_MODAL.HISTORICO) return <Historico dadosExibir={dadosHistorico} />;
      if (modalState?.title === ENUM_MODAL.HISTORICO_RELATORIO_REQUERIMENTO) return <HistoricoRelatorioRequerimento />;
      if (modalState?.title === ENUM_MODAL.SUCESSO_REQUERIMENTO) return <SucessoRequerimento />;
      if (modalState?.title === ENUM_MODAL.LISTA_REATENDIMENTO) return <ReatendimentoAtendente />;
      if (modalState?.title === ENUM_MODAL.RESOLVE_CAPTCHA) return <ValidateCaptcha />;
      if (modalState?.title === ENUM_MODAL.RESUMO_REQUERIMENTO) return <ResumoRequerimento />;
    }
    return <></>;
  };

  return (
    <Modal
      forceRender
      destroyOnClose
      title={modalState?.title}
      centered
      visible={modalState?.isOpen}
      onCancel={onClose}
      closeIcon={<CloseOutlined />}
      width={modalState?.props?.width ?? 800}
      closable={true}
      footer={
        modalState?.title !== ENUM_MODAL.RESOLVE_CAPTCHA && [
          <Button key="back" onClick={onClose}>
            Fechar
          </Button>,
        ]
      }
    >
      <Loading>{chooseModal()}</Loading>
    </Modal>
  );
};

export default ModalGenerico;
